import * as React from 'react'
import { RouteComponentProps } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'
import { ApplicationState } from '../../store'
import { apiCallWrapper, DataTable, DataTableColumnModel, DataTableModel, DataTableModelCustomAction, FilterType, LoadingBlock, nameof, Popup } from 'traveldesk-ui'
import { BookingCustomInput, BookingCustomInputTypeOptions } from '../../models/BookingCustomInput'
import AdminBookingsCustomInputForm from './AdminBookingsCustomInputForm'
interface Props extends RouteComponentProps<{ tab: string }> {}
const AdminBookingsCustomInputs = (props: Props) => {
    const Localization = useSelector((state: ApplicationState) => state.localization.locale)
    const dispatch = useDispatch()
    const [customInputs, setCustomInputs] = React.useState<BookingCustomInput[]>([])
    const [editCustomInput, setEditCustomInput] = React.useState<BookingCustomInput | null>(null)
    const [loading, setLoading] = React.useState(false)
    const getCustomInputs = async () => {
        setLoading(true)
        const response = await apiCallWrapper<BookingCustomInput[]>('api/suppliers/custominputs', 'GET', dispatch)
        if(response.IsOk){
            setCustomInputs(response.Content || [])
        }
        
        setLoading(false)
    }
    React.useEffect(() => {
        getCustomInputs()
    }, [])        
    const initDataTable = () => {
        const columns = [
            new DataTableColumnModel({
                displayName:"#",
                fieldName:"id",
                sortable: true
            }),
            new DataTableColumnModel({
                displayName:"Name",
                fieldName:"name",
                filterType: FilterType.TEXT,
                sortable: true
            }),
            new DataTableColumnModel({
                displayName:"Description",
                fieldName:"description",
                filterType: FilterType.TEXT,
                sortable: true
            }),
            new DataTableColumnModel({
                displayName:"Type",
                fieldName:"type",
                filterType: FilterType.MULTISELECT,
                filterOptions:BookingCustomInputTypeOptions
            }),
            new DataTableColumnModel({
                displayName:"Price",
                fieldName:"price",
            }),
            new DataTableColumnModel({
                displayName:"",
                fieldName:"",
                customRenderer: (obj: BookingCustomInput) => {
                    return <div>
                        <i className="fa fa-edit" onClick={() => setEditCustomInput(obj)}></i>
                    </div>
                }
            })
        ]
        return new DataTableModel({
            columns: columns,
            name: "Custom Inputs",
            fileName: "custom-inputs.xlsx",
            customActions:[
                new DataTableModelCustomAction(() => {setEditCustomInput(new BookingCustomInput())}, () => <i className="fa fa-plus"></i>)
            ]
        });
    };
    const onSave = (model: BookingCustomInput) => {
        setCustomInputs(customInputs.some(item => item.id === model.id) ? customInputs.map((item) => item.id === model.id ? model : item) : customInputs.concat(model))
        setEditCustomInput(model)        
    }
    return (
        <div className="tab-content-block is-active" data-tab="tab-v01">
            {loading && <LoadingBlock />}
            {editCustomInput && <Popup onClose={() => setEditCustomInput(null)}>
                <AdminBookingsCustomInputForm model={editCustomInput} onSave={onSave} onCancel={() => setEditCustomInput(null)} />
            </Popup>}
            <DataTable 
                data={customInputs} 
                dataTable={initDataTable()} 
                onRefreshData={() => getCustomInputs()}
                isFullScreen
            />
        </div>
    );
};
export default AdminBookingsCustomInputs;
